export default __webpack_public_path__ + "static/howFWAWorksStep2-60fb1e5a9d3284ff2ed82665a40fcff5.png";